export
const name: string = "Particles";

export
const preproc: string = ``;

export
const declaration: string = `
    // override default precision specified in defaultPrecision_fs
    precision lowp float;
    precision lowp int;

    uniform sampler2D u_texture;
`;

export
const varyings: string = ``;

export
const implementation: string = `
    void main()
    {
        vec4 texColor = vec4(1.0);
        texColor = texture2D(u_texture, gl_PointCoord.xy);

        gl_FragColor = texColor;

    #ifdef LOGDEPTH
        resolveLogarithmicDepth();
    #endif
    }
`;
